import { API_ENDPOINTS } from "../api-endpoints";
import { HttpClient } from "../http-client";
import { AllUsersInterface, UserBYIdInterFace } from "../types/types";

export const user = {
  GetAllUsers: (options?: any) => {
    return HttpClient.get<AllUsersInterface>(
      API_ENDPOINTS.REGISTERUSERS,
      options
    );
  },
  GetSingleUser: (id?: number) => {
    return HttpClient.get<UserBYIdInterFace>(
      `${API_ENDPOINTS.REGISTERUSERS}/${id}`
    );
  },
  deleteUser: (id: number) => {
    return HttpClient.delete(`${API_ENDPOINTS.REGISTERUSERS}/${id}`);
  },

  ResetPassword: (body: any): Promise<any> => {
    return HttpClient.patch(API_ENDPOINTS.RESET_PASSWORD, body);
  },

};
